import styled from 'styled-components'
import React from 'react'
import { Modal, paddingModalStyles } from '@futures-platform/ui'
import { InfoCircle } from '@styled-icons/boxicons-regular'
import EmbedLinkModal from './EmbedLinkModal'

const InformationModal = ({
  ismrginTopUL2,
  InfoModalHeader,
  InfoModalUL,
  InfoModalUL2,
  InfoModalUL3,
  InfoModalUL4,
  InfoModalDescription,
  InfoModalDescription2,
  InfoModalDescription3,
  InfoModalDescription4,
  InfoModalDescription5,
  InfoModalDescription6,
  InfoModalDescription7,
  InfoModalDescriptionA,
  InfoModalDescriptionSub3,
  InfoModalDescriptionSub2,
  InfoModalDescriptionSub1,
  InfoModalDescriptionB,
  InfoModalDescriptionC,
  InfoModalDescriptionD,
  InfoModalDescriptionE,
  InfoModalDescriptionF,
  InfoModalDescription2A,
  InfoModalDescription2B,
  InfoModalDescription2C,
  InfoModalDescription2D,
  InfoModalDescription2E,
  InfoModalDescription2F,
  InfoModalDescription3A,
  InfoModalDescription3B,
  InfoModalDescription3C,

  InfoModalNote,
  InfoModalOpen,
  InfoModalClose,
  LearnMoreLink,
  GuideLink,
  LearnMoreBtn,
  GuideBtn,
  link3,
  urllink3,
}) => {
  const [openEmbedLinkModalGuideLink, setOpenEmbedLinkModalGuideLink] =
    React.useState(false)
  const [openEmbedLinkModalLearnMoreLink, setOpenEmbedLinkModalLearnMoreLink] =
    React.useState(false)

  // const handleOpenGuideLinkModal = (link) => {
  //   setOpenEmbedLinkModalGuideLink(true)
  //   // window.open(link);
  // };
  // const handleOpenLearnMoreLinkModal = (link) => {
  //   setOpenEmbedLinkModalLearnMoreLink(true)
  //   // window.open(link);
  // };
  return (
    <Modal
      onRequestClose={InfoModalClose}
      isOpen={InfoModalOpen}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div className="confirmation-modal-content ">
        <div
          className="modal-form-section modal-form-header"
          style={{ padding: '32px' }}
          // style={{ marginLeft: '10px' }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <InformationIcon />
            <h3
              style={{
                marginLeft: '20px',
                marginBottom: '0',
                fontSize: '26px',
                fontWeight: 700,
                fontFamily: 'L10',
              }}>
              {InfoModalHeader}
            </h3>
          </div>
          {/* <div style={{ marginLeft: '65px' }}>
            <ul className="mt-4" style={{ padding: 0 }}>{InfoModalNote}</ul>
            <li style={{ marginLeft: '12px', marginTop: '4px' }}>aaaa</li>
          </div> */}

          <InformationUl
            style={{
              marginLeft: '65px',
              marginTop: '24px',
              padding: 0,
              fontSize: '16px',
              // fontWeight: 700,
              fontFamily: 'L10',
            }}>
            {InfoModalUL}
            <div style={{ marginLeft: '24px' }}>
              {InfoModalDescription && (
                <InformationLi>{InfoModalDescription}</InformationLi>
              )}
              {InfoModalDescription2 && (
                <InformationLi>{InfoModalDescription2}</InformationLi>
              )}
              {InfoModalDescriptionSub1 && (
                <InformationLiSub>{InfoModalDescriptionSub1}</InformationLiSub>
              )}
              {InfoModalDescriptionSub2 && (
                <InformationLiSub>{InfoModalDescriptionSub2}</InformationLiSub>
              )}
              {InfoModalDescriptionSub3 && (
                <InformationLiSub>{InfoModalDescriptionSub3}</InformationLiSub>
              )}
              {InfoModalDescription3 && (
                <InformationLi>{InfoModalDescription3}</InformationLi>
              )}
              {InfoModalDescription4 && (
                <InformationLi>{InfoModalDescription4}</InformationLi>
              )}
              {InfoModalDescription5 && (
                <InformationLi>{InfoModalDescription5}</InformationLi>
              )}
              {InfoModalDescription6 && (
                <InformationLi>{InfoModalDescription6}</InformationLi>
              )}
              {InfoModalDescription7 && (
                <InformationLi>{InfoModalDescription7}</InformationLi>
              )}
            </div>
          </InformationUl>

          {!!InfoModalUL2 && (
            <InformationUl
              style={{
                marginLeft: '65px',
                marginTop: !!ismrginTopUL2 ? ismrginTopUL2 + 'px' : '24px',
                padding: 0,
                fontSize: '16px',
                // fontWeight: 700,
                fontFamily: 'L10',
                width: '72%',
              }}>
              {InfoModalUL2}
              <div style={{ marginLeft: '24px' }}>
                {InfoModalDescriptionA && (
                  <InformationLi>{InfoModalDescriptionA}</InformationLi>
                )}

                {InfoModalDescriptionB && (
                  <InformationLi>{InfoModalDescriptionB}</InformationLi>
                )}
                {InfoModalDescriptionC && (
                  <InformationLi>{InfoModalDescriptionC}</InformationLi>
                )}
                {InfoModalDescriptionD && (
                  <InformationLi>{InfoModalDescriptionD}</InformationLi>
                )}
                {InfoModalDescriptionE && (
                  <InformationLi>{InfoModalDescriptionE}</InformationLi>
                )}
                {InfoModalDescriptionF && (
                  <InformationLi>{InfoModalDescriptionF}</InformationLi>
                )}
              </div>
            </InformationUl>
          )}

          {!!InfoModalUL3 && (
            <InformationUl
              style={{
                marginLeft: '65px',
                marginTop: '24px',
                padding: 0,
                fontSize: '16px',
                // fontWeight: 700,
                fontFamily: 'L10',
              }}>
              {InfoModalUL3}
              <div style={{ marginLeft: '24px' }}>
                {InfoModalDescription2A && (
                  <InformationLi>{InfoModalDescription2A}</InformationLi>
                )}
                {InfoModalDescription2B && (
                  <InformationLi>{InfoModalDescription2B}</InformationLi>
                )}
                {InfoModalDescription2C && (
                  <InformationLi>{InfoModalDescription2C}</InformationLi>
                )}
                {InfoModalDescription2D && (
                  <InformationLi>{InfoModalDescription2D}</InformationLi>
                )}
                {InfoModalDescription2E && (
                  <InformationLi>{InfoModalDescription2E}</InformationLi>
                )}
                {InfoModalDescription2F && (
                  <InformationLi>{InfoModalDescription2F}</InformationLi>
                )}
              </div>
            </InformationUl>
          )}
          {!!InfoModalUL4 && (
            <InformationUl
              style={{
                marginLeft: '65px',
                marginTop: '24px',
                padding: 0,
                fontSize: '16px',
                // fontWeight: 700,
                fontFamily: 'L10',
              }}>
              {InfoModalUL4}
              <div style={{ marginLeft: '24px' }}>
                {InfoModalDescription3A && (
                  <InformationLi>{InfoModalDescription3A}</InformationLi>
                )}
                {InfoModalDescription3B && (
                  <InformationLi>{InfoModalDescription3B}</InformationLi>
                )}
                {InfoModalDescription3C && (
                  <InformationLi>{InfoModalDescription3C}</InformationLi>
                )}
              </div>
            </InformationUl>
          )}
          {(!!LearnMoreBtn || !!GuideLink || !!link3) && (
            <div
              style={{
                marginTop: '48px',
                display: 'flex',
                flexDirection: 'column',
                width: '60%',
                marginLeft: '65px',
              }}>
              <h6
                style={{
                  fontSize: '16px',
                  // fontWeight: 700,
                  fontFamily: 'L10',
                }}>
                {'Learn more from the HUB:'}
              </h6>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {!!LearnMoreBtn && (
                  <button
                    style={{
                      fontSize: '14px',
                      // fontWeight: 700,
                      fontFamily: 'L10',
                      textTransform: 'unset',
                    }}
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => window.open(LearnMoreLink)}>
                    {LearnMoreBtn}
                  </button>
                )}
                {!!GuideLink && (
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    style={{
                      marginTop: '17px',
                      fontSize: '14px',
                      // fontWeight: 700,
                      fontFamily: 'L10',
                      textTransform: 'unset',
                    }}
                    onClick={() => window.open(GuideLink)}>
                    {GuideBtn}
                  </button>
                )}

                {!!link3 && (
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    style={{
                      marginTop: '17px',
                      fontSize: '14px',
                      // fontWeight: 700,
                      fontFamily: 'L10',
                      textTransform: 'unset',
                    }}
                    onClick={() => window.open(urllink3)}>
                    {link3}
                  </button>
                )}
              </div>
            </div>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: '30px',
            }}>
            <button
              className="btn btn-primary btn-lg btn-primary"
              onClick={InfoModalClose}>
              GOT IT
            </button>
          </div>
        </div>
      </div>
      <EmbedLinkModal
        EmbedLinkModalOpen={openEmbedLinkModalGuideLink}
        EmbedLinkModalClose={() => setOpenEmbedLinkModalGuideLink(false)}
        EmbedLink={GuideLink}
      />
      <EmbedLinkModal
        EmbedLinkModalOpen={openEmbedLinkModalLearnMoreLink}
        EmbedLinkModalClose={() => setOpenEmbedLinkModalLearnMoreLink(false)}
        EmbedLink={LearnMoreLink}
      />
    </Modal>
  )
}

export default InformationModal

const InformationIcon = styled(InfoCircle)`
  background-color: white;
  color: #00c3ff;
  width: 45px;
  height: 45px;
`
const InformationUl = styled.ul`
  width: '72%';
`
const InformationLi = styled.li`
  line-height: 1.4
  margin-top: 8px;
  margin-bottom: 8px;
`
const InformationLiSub = styled.li`
  line-height: 1.4
  margin-top: 8px;
  margin-bottom: 8px;
  margin-left: 12px;
  list-style-type: "-";
  padding-left: 8px;
`

const InformationLink = styled.button`
  color: #006998;
  &:hover {
    cursor: pointer;
  }
`
